/**
 * Application entry point.
 *
 * This file includes `import`'s for all the components/directives used
 * by the HTML page and the controller to provide the configuration.
 */

import './sass/iframe_api.scss';
import 'gmf/controllers/iframe_api.scss';
import 'gmf/controllers/vars_desktop.scss';

import angular from 'angular';
import gmfControllersAbstractAPIController, {
  AbstractAPIController,
} from 'gmf/controllers/AbstractAPIController';
import morgesBase from '../morgesmodule';

/**
 * @private
 */
class Controller extends AbstractAPIController {}

/**
 * @hidden
 */
const morgesModule = angular.module('Appiframe_api', [
  morgesBase.name,
  gmfControllersAbstractAPIController.name,
]);

morgesModule.controller('IframeAPIController', Controller);

export default morgesModule;
